import { PROFESSION_IDS, LEVEL_IDS, PROF_T } from "../content/professions";

const LBL = { sk: ["Profesia", "Úroveň (a vyššia)", "— akákoľvek —"], en: ["Profession", "Level (or higher)", "— any —"], de: ["Beruf", "Stufe (oder höher)", "— beliebig —"], pl: ["Zawód", "Poziom (lub wyższy)", "— dowolny —"], fr: ["Métier", "Niveau (ou supérieur)", "— tous —"] };
const sel = "bg-black border border-white/15 text-white text-sm px-3 py-2 focus:border-[#D4AF37] outline-none";

export default function ProfLevelFilter({ lang, value, onChange, testid = "prof-level-filter" }) {
  const T = PROF_T[lang] || PROF_T.sk;
  const L = LBL[lang] || LBL.sk;
  return (
    <div className="flex flex-wrap items-end gap-3" data-testid={testid}>
      <label className="text-[11px] tracking-[0.2em] uppercase text-[#D4AF37]/75 flex flex-col gap-1.5">{L[0]}
        <select className={sel} value={value.prof} onChange={(e) => onChange({ prof: e.target.value, level: e.target.value ? value.level : "" })} data-testid={`${testid}-prof`}>
          <option value="">{L[2]}</option>
          {PROFESSION_IDS.filter((p) => p !== "other").map((p) => <option key={p} value={p}>{T.names[p]}</option>)}
        </select>
      </label>
      {value.prof && (
        <label className="text-[11px] tracking-[0.2em] uppercase text-[#D4AF37]/75 flex flex-col gap-1.5">{L[1]}
          <select className={sel} value={value.level} onChange={(e) => onChange({ ...value, level: e.target.value })} data-testid={`${testid}-level`}>
            <option value="">{L[2]}</option>
            {LEVEL_IDS.map((l) => <option key={l} value={l}>{T.levels[l]}</option>)}
          </select>
        </label>
      )}
    </div>
  );
}

export const pfParams = (pf) => `&prof=${encodeURIComponent(pf.prof || "")}&level=${encodeURIComponent(pf.level || "")}`;
